import Module, { getStaticProps } from './index'
export default Module
export { getStaticProps }

export async function getStaticPaths () {
  return {
    paths: [],
    fallback: true
  }
}
